/** @jsx jsx */
import { jsx, ThemeUIStyleObject } from "theme-ui";
import React from "react";
import { AspectRatio } from "@shared-components/AspectRatio/AspectRatio";
import { Box } from "@shared-components/Box/Box";
import { ButtonLink } from "@shared-components/Button/Button";
import {
  downloadAspectStyles,
  downloadButtonStyle,
  downloadStyle,
  downloadTextBoxStyle,
} from "./styles";
// import { BackgroundVideo } from "@shared-components/BackgroundVideo/BackgroundVideo";
import { UmbracoBackgroundImage } from "@shared-components/Image/UmbracoBackgroundImage/UmbracoBackgroundImage";
import { useDictionaryContext } from "../../../context/dictionary/useDictionaryContext";
import { useSiteContext } from "../../../context/site/useSiteContext";
import { DICTIONARY_MAP } from "../../../carlsberg-headless/dictionary-map";
import { useWindowSize } from "../../../shared/hooks/useWindowSize/useWindowSize";
import { VideoPlayer } from "../VideoPlayer/VideoPlayer";

export interface VideoLinkProps {
  stylingprop?: ThemeUIStyleObject;
  theme: string;
  cbKey: string;
  media: {
    format: string;
    src: string;
    link: string;
    videoId: string | undefined;
    noSound?: boolean;
  };
  videoTitle?: string;
}

const VideoLink: React.FC<VideoLinkProps> = ({
  cbKey,
  stylingprop,
  media,
  theme,
  videoTitle,
}) => {
  const { get } = useDictionaryContext();
  const { currentCulture } = useSiteContext();
  const isDark = theme === "dark";

  const windowSize = useWindowSize();
  const isMobile = windowSize.width && windowSize.width < 768;

  if (!media) {
    return null;
  }

  return (
    <Box
      key={cbKey}
      sx={{
        ...downloadStyle,
        ...stylingprop,
        color: isDark ? "white" : "darkGreen",
      }}
    >
      <AspectRatio ratio={"400:400"} sx={{ ...downloadAspectStyles }}>
        {media.format.split("/")[0] === "mp4" && media.src && (
          <VideoPlayer
            src={
              media.src.includes("cloudinary")
                ? `${media.src.split("upload/")[0]}upload/q_80/${
                    isMobile ? "w_700" : "w_400"
                  }/${media.src.split("upload/")[1]}`
                : media.src
            }
            extention={"mp4"}
            noSound={media.noSound}
            videoTitle={videoTitle}
          />
        )}
        {media.format.split("/")[0] != "mp4" &&
          media.format.split("/")[0] === "image" &&
          media.src && (
            <UmbracoBackgroundImage
              image={{
                alias: null,
                url: null,
                fullUrl: media.src,
                width: 4,
                height: 8,
                extension: null,
                size: null,
                focalPoint: { top: 0, left: 0 },
                altText: null,
              }}
              sx={{ objectFit: "contain" }}
              width={["300px", "600px"]}
            />
          )}
      </AspectRatio>
      <Box sx={downloadTextBoxStyle}>
        <ButtonLink
          to={
            media.link.includes("cloudinary")
              ? `${media.link.split("upload/")[0]}upload/fl_attachment/${
                  media.link.split("upload/")[1]
                }`
              : media.link
          }
          {...(media.link.includes("cloudinary") && { download: true })}
          variant={isDark ? "white" : "green"}
          outline
          sx={downloadButtonStyle}
        >
          {get(
            DICTIONARY_MAP.digital_memories.digital_memories_future_button_text,
            currentCulture
          ) ?? null}
        </ButtonLink>
      </Box>
    </Box>
  );
};

export { VideoLink };
